import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, { color: "rgba(0,0,0,0)" }, {
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    "x-large": "",
                    href: "mailto:mario@marionovak.com"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("h2", null, "Mail", -1)
                    ])),
                    _: 1,
                    __: [0]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    "x-large": "",
                    href: "/file/cv.pdf"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("h2", null, "CV.pdf", -1)
                    ])),
                    _: 1,
                    __: [1]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://github.com/moltouni"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("h3", null, "GitHub", -1)
                ])),
                _: 1,
                __: [2]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://www.linkedin.com/in/moltouni/"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("h3", null, "LinkedIn", -1)
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://medium.com/@moltouni"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("h3", null, "Medium", -1)
                ])),
                _: 1,
                __: [4]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://twitter.com/@moltouni"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("h3", null, "Twitter", -1)
                ])),
                _: 1,
                __: [5]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://www.mixcloud.com/moltouni/"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("h3", null, "MixCloud", -1)
                ])),
                _: 1,
                __: [6]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://dev.to/moltouni"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("h3", null, "Dev.to", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://soundcloud.com/moltouni"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("h3", null, "SoundCloud", -1)
                ])),
                _: 1,
                __: [8]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://youtube.com/moltouni"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("h3", null, "YouTube", -1)
                ])),
                _: 1,
                __: [9]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://www.patreon.com/moltouni"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("h3", null, "Patreon - Monthly", -1)
                ])),
                _: 1,
                __: [10]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                "x-large": "",
                href: "https://www.buymeacoffee.com/moltouni"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createElementVNode("h3", null, "Buy Me A Coffee - Once", -1)
                ])),
                _: 1,
                __: [11]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    "x-large": "",
                    href: "https://andromeda.technology",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("h3", null, "Andromeda.Technology", -1)
                    ])),
                    _: 1,
                    __: [12]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}